/* eslint-disable */
import {
  LayoutGrid, Trophy, Smile, Sparkles, Bot, Settings, Crown, Smile as Emoji,
  HandHelping, MessageSquareHeart, Heart, Hammer, Award, Star,
  Workflow, Terminal, UserPlus, Ticket,
  BarChart3, MessageSquare, Search, HelpCircle, Bell, TrendingUp, Hash,
  Twitch, Music as TikTokIcon, Twitter, Cloud, Youtube, MessageCircle, Instagram, Rss, ZapIcon, Mic2,
  Gift, Cake, Landmark,
  Gem, HandCoins,
  Wallet, ImageIcon, ShoppingBag, LineChart, Coins, Fuel, Lock,
  Music, Volume2, Shield, CreditCard,
} from "lucide-react";

export const FEATURE_GROUPS = [
  {
    label: null,
    items: [
      { id: "overview",       to: "/dashboard",                  label: "Dashboard",        icon: LayoutGrid, status: "live" },
      { id: "leaderboard",    to: "/dashboard/leaderboard",      label: "Leaderboard",      icon: Trophy,     status: "live" },
      { id: "personalizer",   to: "/dashboard/personalizer",     label: "Bot Personalizer", icon: Sparkles,   status: "live" },
      { id: "ai-characters",  to: "/dashboard/ai-characters",    label: "AI Characters",    icon: Bot,        status: "soon" },
      { id: "ai",             to: "/dashboard/ai",               label: "606 AI Chat",      icon: Bot,        status: "live" },
      { id: "settings",       to: "/dashboard/settings",         label: "Settings",         icon: Settings,   status: "live" },
      { id: "pricing",        to: "/dashboard/pricing",          label: "Premium",          icon: Crown,      status: "live" },
      { id: "emojis",         to: "/dashboard/emojis",           label: "Emojis",           icon: Emoji,      status: "soon" },
    ],
  },
  {
    label: "Music & Server",
    items: [
      { id: "music",      to: "/dashboard/music",       label: "Music Player",  icon: Music,    status: "live" },
      { id: "channels",   to: "/dashboard/channels",    label: "Channels",      icon: Volume2,  status: "live" },
      { id: "members",    to: "/dashboard/members",     label: "Members",       icon: Shield,   status: "live" },
    ],
  },
  {
    label: "Essentials",
    items: [
      { id: "welcome",        to: "/dashboard/welcome",       label: "Welcome & Goodbye", icon: HandHelping,        status: "live" },
      { id: "welcome-channel",to: "/dashboard/welcome-channel",label: "Welcome Channel",   icon: MessageSquareHeart, status: "live" },
      { id: "reaction-roles", to: "/dashboard/reaction-roles", label: "Reaction Roles",    icon: Heart,              status: "live" },
      { id: "moderator",      to: "/dashboard/moderator",      label: "Moderator",         icon: Hammer,             status: "live" },
      { id: "levels",         to: "/dashboard/levels",         label: "Levels",            icon: Trophy,             status: "live" },
      { id: "achievements",   to: "/dashboard/achievements",   label: "Achievements",      icon: Award,              status: "soon" },
      { id: "starboards",     to: "/dashboard/starboards",     label: "Starboards",        icon: Star,               status: "soon" },
    ],
  },
  {
    label: "Server Management",
    items: [
      { id: "automations",     to: "/dashboard/automations",     label: "Automations",     icon: Workflow,  status: "soon" },
      { id: "custom-commands", to: "/dashboard/custom-commands", label: "Custom Commands", icon: Terminal,  status: "live" },
      { id: "invite-tracker",  to: "/dashboard/invite-tracker",  label: "Invite Tracker",  icon: UserPlus,  status: "live" },
      { id: "ticketing",       to: "/dashboard/ticketing",       label: "Ticketing",       icon: Ticket,    status: "soon" },
    ],
  },
  {
    label: "Utilities",
    items: [
      { id: "polls",          to: "/dashboard/polls",          label: "Polls",              icon: BarChart3,    status: "live" },
      { id: "embed-messages", to: "/dashboard/embed-messages", label: "Embed Messages",     icon: MessageSquare,status: "live" },
      { id: "search",         to: "/dashboard/search",         label: "Search Anything",    icon: Search,       status: "soon" },
      { id: "help",           to: "/dashboard/help",           label: "Help",               icon: HelpCircle,   status: "live" },
      { id: "reminders",      to: "/dashboard/reminders",      label: "Reminders",          icon: Bell,         status: "live" },
      { id: "stats-channels", to: "/dashboard/stats-channels", label: "Statistics Channels",icon: TrendingUp,   status: "live" },
      { id: "temp-channels",  to: "/dashboard/temp-channels",  label: "Temporary Channels", icon: Hash,         status: "live" },
    ],
  },
  {
    label: "Social Alerts",
    items: [
      { id: "twitch-alerts",   to: "/dashboard/twitch-alerts",   label: "Twitch Alerts",   icon: Twitch,       status: "soon" },
      { id: "tiktok-alerts",   to: "/dashboard/tiktok-alerts",   label: "TikTok Alerts",   icon: TikTokIcon,   status: "soon" },
      { id: "x-alerts",        to: "/dashboard/x-alerts",        label: "X Alerts",        icon: Twitter,      status: "soon" },
      { id: "bluesky-alerts",  to: "/dashboard/bluesky-alerts",  label: "Bluesky Alerts",  icon: Cloud,        status: "soon" },
      { id: "youtube-alerts",  to: "/dashboard/youtube-alerts",  label: "YouTube Alerts",  icon: Youtube,      status: "soon" },
      { id: "reddit-alerts",   to: "/dashboard/reddit-alerts",   label: "Reddit Alerts",   icon: MessageCircle,status: "soon" },
      { id: "instagram-alerts",to: "/dashboard/instagram-alerts",label: "Instagram Alerts",icon: Instagram,    status: "soon" },
      { id: "rss-feeds",       to: "/dashboard/rss-feeds",       label: "RSS Feeds",       icon: Rss,          status: "soon" },
      { id: "kick-alerts",     to: "/dashboard/kick-alerts",     label: "Kick Alerts",     icon: ZapIcon,      status: "soon" },
      { id: "podcast-alerts",  to: "/dashboard/podcast-alerts",  label: "Podcast Alerts",  icon: Mic2,         status: "soon" },
    ],
  },
  {
    label: "Games & Fun",
    items: [
      { id: "giveaways", to: "/dashboard/giveaways", label: "Giveaways", icon: Gift,     status: "live" },
      { id: "birthdays", to: "/dashboard/birthdays", label: "Birthdays", icon: Cake,     status: "live" },
      { id: "economy",   to: "/dashboard/economy",   label: "Economy",   icon: Landmark, status: "live" },
    ],
  },
  {
    label: "Monetization",
    items: [
      { id: "monetize",     to: "/dashboard/monetize",     label: "Monetize",     icon: Gem,       status: "soon" },
      { id: "sponsorships", to: "/dashboard/sponsorships", label: "Sponsorships", icon: HandCoins, status: "soon", badge: "Beta" },
    ],
  },
  {
    label: "Web3",
    items: [
      { id: "web3-sub",          to: "/dashboard/web3-sub",          label: "Web3 Subscription", icon: Wallet,     status: "soon" },
      { id: "web3-stats",        to: "/dashboard/web3-stats",        label: "Statistics Channels",icon: LineChart, status: "soon" },
      { id: "nft-queries",       to: "/dashboard/nft-queries",       label: "NFT Queries",       icon: Search,     status: "soon" },
      { id: "nft-sales",         to: "/dashboard/nft-sales",         label: "NFT Sales & Listing",icon: ShoppingBag,status: "soon" },
      { id: "crypto-stats",      to: "/dashboard/crypto-stats",      label: "Crypto Statistics", icon: TrendingUp, status: "soon" },
      { id: "crypto-queries",    to: "/dashboard/crypto-queries",    label: "Crypto Queries",    icon: Coins,      status: "soon" },
      { id: "gas-tracker",       to: "/dashboard/gas-tracker",       label: "Gas Tracker",       icon: Fuel,       status: "soon" },
      { id: "gating",            to: "/dashboard/gating",            label: "Gating",            icon: Lock,       status: "soon" },
    ],
  },
];
